import Http from './http';
import store from 'store';

class JurisdictionService {
    constructor() {
        this.jurisdiction = null;
    }

    resetCache(){
        if (!this.jurisdiction) return;
        store.set('jurisdiction', false)
        this.jurisdiction = null;
        this.getJurisdiction()
    }

    prepareJurisdictionsTree(data) {
        const jurisdictions = [];
        const jurCodes = {};
        
        data.forEach(item => {
            item = { ...item, Id: item.value, Name: item.label  };
            
            if (!item.region) jurisdictions.push(item);
            else {
                if (!jurCodes.hasOwnProperty(item.region)) jurCodes[item.region] = [];
                jurCodes[item.region].push(item);
            }
        });
        
        jurisdictions.forEach(item => {
            item.Items = jurCodes[item.value];
        });
        return jurisdictions;
    }

    getJurisdiction() {
        return new Promise((resolve, reject) => {
            if (store.get('jurisdiction', false)){
                this.jurisdiction = store.get('jurisdiction');
            }
            if (this.jurisdiction) resolve(this.jurisdiction);
            else {
                Http.get('/regulators/jurisdictions/').then(resp => {
                    this.jurisdiction = this.prepareJurisdictionsTree(resp.data.countries);
                    store.set('jurisdiction', this.jurisdiction)
                    resolve(this.jurisdiction);
                });
            }
        })
    }
}

export default new JurisdictionService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/jurisdiction.js